import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import memoize from 'memoizee';
import { StringValue } from 'google-protobuf/google/protobuf/wrappers_pb';
import { DraftServicePromiseClient } from '@taxfyle/api-internal/internal/draft_grpc_web_pb';
import { createGrpcAuthenticator } from '../misc/grpc-authenticator';
import { ReplaceDraftQuestionAnswersRequest, CreateDraftJobRequest, CreateDraftJobForTeamRequest, RequestChampionProviderRequest, SubmitDraftJobRequest, GetJobSubmissionProgressRequest, GetQuoteRequest, ArchiveDraftRequest, ApplyCouponRequest, RemoveCouponRequest, ListPreviousProvidersRequest, UpgradeLegendRequest, GetMatchingProvidersCountRequest } from '@taxfyle/api-internal/internal/draft_pb';
import { enableDevTools } from '../utils/grpcUtil';
import QuestionMapper from '../jobs/mappers/QuestionMapper';
var createDraftsClient = memoize(function (baseUrl) {
  var client = new DraftServicePromiseClient(baseUrl);
  enableDevTools(client);
  return client;
});
export var DraftApi = /*#__PURE__*/function () {
  function DraftApi(opts) {
    _classCallCheck(this, DraftApi);
    this.client = createDraftsClient(opts.baseURL);
    this.grpcAuthenticator = createGrpcAuthenticator({
      token$: opts.token$
    });
  }
  return _createClass(DraftApi, [{
    key: "replaceQuestionAnswers",
    value: function () {
      var _replaceQuestionAnswers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(draftId, questions) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              payload = new ReplaceDraftQuestionAnswersRequest().setId(draftId);
              questions.forEach(function (question) {
                payload.getAnswersMap().set(question.id, QuestionMapper.toDto(question));
              });
              _context.t0 = this.client;
              _context.t1 = payload;
              _context.next = 6;
              return this.grpcAuthenticator.getMeta();
            case 6:
              _context.t2 = _context.sent;
              _context.next = 9;
              return _context.t0.replaceDraftQuestionAnswers.call(_context.t0, _context.t1, _context.t2);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function replaceQuestionAnswers(_x, _x2) {
        return _replaceQuestionAnswers.apply(this, arguments);
      }
      return replaceQuestionAnswers;
    }()
    /**
     * @param {string} id - Id of the job
     * @param {string?} billingMethodId - (optional) The id of the billing method in which to charge
     * @param {string?} bypassBilling - (optional) Default to false, and if true, disables billing for the job
     */
  }, {
    key: "submitDraftJob",
    value: (function () {
      var _submitDraftJob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, billingMethodId) {
        var bypassBilling,
          payload,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              bypassBilling = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
              payload = new SubmitDraftJobRequest().setId(id).setBypassBilling(bypassBilling);
              if (billingMethodId) {
                payload.setBillingMethodId(new StringValue().setValue(billingMethodId));
              }
              _context2.t0 = this.client;
              _context2.t1 = payload;
              _context2.next = 7;
              return this.grpcAuthenticator.getMeta();
            case 7:
              _context2.t2 = _context2.sent;
              return _context2.abrupt("return", _context2.t0.submitDraftJob.call(_context2.t0, _context2.t1, _context2.t2));
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function submitDraftJob(_x3, _x4) {
        return _submitDraftJob.apply(this, arguments);
      }
      return submitDraftJob;
    }()
    /**
     *
     * @param {string} id
     */
    )
  }, {
    key: "getJobSubmissionProgress",
    value: (function () {
      var _getJobSubmissionProgress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              payload = new GetJobSubmissionProgressRequest().setSubmissionId(id);
              _context3.t0 = this.client;
              _context3.t1 = payload;
              _context3.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context3.t2 = _context3.sent;
              return _context3.abrupt("return", _context3.t0.getJobSubmissionProgress.call(_context3.t0, _context3.t1, _context3.t2));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getJobSubmissionProgress(_x5) {
        return _getJobSubmissionProgress.apply(this, arguments);
      }
      return getJobSubmissionProgress;
    }())
  }, {
    key: "createDraftJob",
    value: function () {
      var _createDraftJob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(legendId, legendVersion, clientUserPublicId) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              payload = new CreateDraftJobRequest().setLegendId(legendId).setLegendVersion(legendVersion).setClientUserPublicId(clientUserPublicId);
              _context4.t0 = this.client;
              _context4.t1 = payload;
              _context4.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context4.t2 = _context4.sent;
              _context4.next = 8;
              return _context4.t0.createDraftJob.call(_context4.t0, _context4.t1, _context4.t2).then(function (response) {
                return response.getId();
              });
            case 8:
              return _context4.abrupt("return", _context4.sent);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function createDraftJob(_x6, _x7, _x8) {
        return _createDraftJob.apply(this, arguments);
      }
      return createDraftJob;
    }()
  }, {
    key: "createTeamDraftJob",
    value: function () {
      var _createTeamDraftJob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(legendId, legendVersion, teamId, clientUserPublicId) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              payload = new CreateDraftJobForTeamRequest().setLegendId(legendId).setLegendVersion(legendVersion).setTeamId(teamId).setClientUserPublicId(clientUserPublicId);
              _context5.t0 = this.client;
              _context5.t1 = payload;
              _context5.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context5.t2 = _context5.sent;
              _context5.next = 8;
              return _context5.t0.createDraftJobForTeam.call(_context5.t0, _context5.t1, _context5.t2).then(function (response) {
                return response.getId();
              });
            case 8:
              return _context5.abrupt("return", _context5.sent);
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function createTeamDraftJob(_x9, _x10, _x11, _x12) {
        return _createTeamDraftJob.apply(this, arguments);
      }
      return createTeamDraftJob;
    }()
  }, {
    key: "requestChampionProvider",
    value: function () {
      var _requestChampionProvider = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(draftId, championProviderId) {
        var payload, championProviderIdValue;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              payload = new RequestChampionProviderRequest().setId(draftId);
              if (championProviderId) {
                championProviderIdValue = new StringValue();
                championProviderIdValue.setValue(championProviderId);
                payload.setProviderUserPublicId(championProviderIdValue);
              }
              _context6.t0 = this.client;
              _context6.t1 = payload;
              _context6.next = 6;
              return this.grpcAuthenticator.getMeta();
            case 6:
              _context6.t2 = _context6.sent;
              _context6.next = 9;
              return _context6.t0.requestChampionProvider.call(_context6.t0, _context6.t1, _context6.t2);
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function requestChampionProvider(_x13, _x14) {
        return _requestChampionProvider.apply(this, arguments);
      }
      return requestChampionProvider;
    }()
  }, {
    key: "archive",
    value: function () {
      var _archive = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(draftId) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              payload = new ArchiveDraftRequest().setId(draftId);
              _context7.t0 = this.client;
              _context7.t1 = payload;
              _context7.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context7.t2 = _context7.sent;
              _context7.next = 8;
              return _context7.t0.archive.call(_context7.t0, _context7.t1, _context7.t2);
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function archive(_x15) {
        return _archive.apply(this, arguments);
      }
      return archive;
    }()
    /**
     * Gets quote for a draft.
     *
     * @param {string} draftId.
     * @returns {Promise<void>}
     */
  }, {
    key: "getQuote",
    value: (function () {
      var _getQuote = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(draftId) {
        var request;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              request = new GetQuoteRequest().setId(draftId);
              _context8.t0 = this.client;
              _context8.t1 = request;
              _context8.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context8.t2 = _context8.sent;
              return _context8.abrupt("return", _context8.t0.getQuote.call(_context8.t0, _context8.t1, _context8.t2).then(function (res) {
                return res.toObject();
              }));
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getQuote(_x16) {
        return _getQuote.apply(this, arguments);
      }
      return getQuote;
    }())
  }, {
    key: "applyCoupon",
    value: function () {
      var _applyCoupon = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(draftId, couponId) {
        var payload, couponIdValue;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              payload = new ApplyCouponRequest().setId(draftId);
              couponIdValue = new StringValue();
              couponIdValue.setValue(couponId);
              payload.setCouponId(couponIdValue);
              _context9.t0 = this.client;
              _context9.t1 = payload;
              _context9.next = 8;
              return this.grpcAuthenticator.getMeta();
            case 8:
              _context9.t2 = _context9.sent;
              _context9.next = 11;
              return _context9.t0.applyCoupon.call(_context9.t0, _context9.t1, _context9.t2);
            case 11:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function applyCoupon(_x17, _x18) {
        return _applyCoupon.apply(this, arguments);
      }
      return applyCoupon;
    }()
  }, {
    key: "removeCoupon",
    value: function () {
      var _removeCoupon = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(draftId) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              payload = new RemoveCouponRequest().setId(draftId);
              _context10.t0 = this.client;
              _context10.t1 = payload;
              _context10.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context10.t2 = _context10.sent;
              _context10.next = 8;
              return _context10.t0.removeCoupon.call(_context10.t0, _context10.t1, _context10.t2);
            case 8:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function removeCoupon(_x19) {
        return _removeCoupon.apply(this, arguments);
      }
      return removeCoupon;
    }()
  }, {
    key: "upgradeLegend",
    value: function () {
      var _upgradeLegend = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(draftId) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              payload = new UpgradeLegendRequest().setId(draftId);
              _context11.t0 = this.client;
              _context11.t1 = payload;
              _context11.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context11.t2 = _context11.sent;
              return _context11.abrupt("return", _context11.t0.upgradeLegend.call(_context11.t0, _context11.t1, _context11.t2).then(function (res) {
                return res.toObject();
              }));
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function upgradeLegend(_x20) {
        return _upgradeLegend.apply(this, arguments);
      }
      return upgradeLegend;
    }()
    /**
     * Fetches previous providers for a given user and workspace.
     *
     * @param {string} workspaceId - The workspace ID.
     * @param {string} userPublicId - The user public ID.
     * @returns {Promise<{ previousProvidersList: Provider[] }>}
     */
  }, {
    key: "listPreviousProviders",
    value: (function () {
      var _listPreviousProviders = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(workspaceId, userPublicId) {
        var request;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              request = new ListPreviousProvidersRequest().setWorkspaceId(workspaceId).setUserPublicId(userPublicId);
              _context12.t0 = this.client;
              _context12.t1 = request;
              _context12.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context12.t2 = _context12.sent;
              return _context12.abrupt("return", _context12.t0.listPreviousProviders.call(_context12.t0, _context12.t1, _context12.t2).then(function (res) {
                return res.toObject();
              }));
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function listPreviousProviders(_x21, _x22) {
        return _listPreviousProviders.apply(this, arguments);
      }
      return listPreviousProviders;
    }()
    /**
     * Fetches matching providers count.
     *
     * @param {string} id - The job ID.
     * @returns {Promise<{ matchingProvidersCount: number }>}
     */
    )
  }, {
    key: "getMatchingProvidersCount",
    value: (function () {
      var _getMatchingProvidersCount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(id) {
        var request;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              request = new GetMatchingProvidersCountRequest().setId(id);
              _context13.t0 = this.client;
              _context13.t1 = request;
              _context13.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context13.t2 = _context13.sent;
              return _context13.abrupt("return", _context13.t0.getMatchingProvidersCount.call(_context13.t0, _context13.t1, _context13.t2).then(function (res) {
                return res.toObject();
              }));
            case 7:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function getMatchingProvidersCount(_x23) {
        return _getMatchingProvidersCount.apply(this, arguments);
      }
      return getMatchingProvidersCount;
    }())
  }]);
}();
//# sourceMappingURL=API.js.map
